import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { UIHeadingTracking } from "./ui-heading-tracking.enum";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ui-heading',
    templateUrl: './ui-heading.component.html',
})
export class UIHeadingComponent implements AfterViewInit {
    @ViewChild('heading') heading: ElementRef<HTMLSpanElement>;

    @Input() tracking: UIHeadingTracking | string = UIHeadingTracking.normal;
    @Input() headingStyle: 'normal' | 'uppercase-wide' = 'normal';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';
    @Input() bold = true;
    @Input() margin = true;
    UIHeadingTracking = UIHeadingTracking;

    ngAfterViewInit(): void {
        this.removeAnythingOtherThanText();
    }

    removeAnythingOtherThanText() {
        Array.from(this.heading.nativeElement.childNodes).forEach(child => {
            if (child instanceof HTMLElement) {
                child.remove();
            }
        });
    }

    trackingIs(tracking: UIHeadingTracking | string): boolean {
        return tracking === this.tracking || tracking === UIHeadingTracking[this.tracking];
    }
}
